import { Link } from 'react-router-dom';
import { Button } from '@repo/ui/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui/components/ui/card';
import { Home, RefreshCw, WifiOff } from 'lucide-react';

export default function OfflinePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
            <WifiOff className="w-8 h-8 text-orange-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">
            Hors ligne
          </CardTitle>
          <CardDescription className="text-gray-600">
            Vous n'êtes pas connecté à Internet. Vérifiez votre connexion et réessayez.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-sm text-gray-500">
            <p>Dendromap fonctionne hors ligne pour certaines fonctionnalités.</p>
            <p>Reconnectez-vous pour accéder à toutes les fonctionnalités.</p>
          </div>

          <div className="flex flex-col space-y-2">
            <Button
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.location.reload();
                }
              }}
              className="w-full"
              variant="default"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Réessayer
            </Button>

            <Button
              asChild
              variant="outline"
              className="w-full"
            >
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                Retour à l'accueil
              </Link>
            </Button>
          </div>

          <div className="text-xs text-gray-400 text-center">
            <p>Dendromap v1.5.1</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
